import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHourglassFullComponent } from "./med-icon-hourglass-full.component";

@NgModule({
  declarations: [
    MedIconHourglassFullComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHourglassFullComponent,
  ],
})
export class MedIconHourglassFullModule { }
